// extracted by mini-css-extract-plugin
export default {"carouselImage":"app_carouselImage__L5de2"};